export default "__VITE_ASSET__BxyRG6LI__"